module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/186-dominica-8b393e5b92645bf15f70756c09744fbf.svg";